export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"},{"name":"robots","content":"index, follow"},{"name":"description","content":"Discover real flavours. Support independent Makers. Delivered by &Dine."},{"name":"facebook-domain-verification","content":"tvob3zh55gcidd4xe9tshq0ebbv6wm"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@nuxt_js"},{"name":"twitter:url","content":"https://anddine.co.uk/"},{"name":"twitter:title","content":"&Dine"},{"name":"twitter:description","content":"Discover real flavours. Support independent Makers. Delivered by &Dine."},{"name":"twitter:image","content":"https://anddinestorage.s3.eu-west-2.amazonaws.com/Images/meal-box/Dine_SpringOffice-49.jpg"},{"name":"og:site_name","content":"&Dine"},{"name":"og:type","content":"website"},{"name":"og:url","content":"https://anddine.co.uk/"},{"name":"og:title","content":"&Dine"},{"name":"og:description","content":"Discover real flavours. Support independent Makers. Delivered by &Dine."},{"name":"og:image","content":"https://anddinestorage.s3.eu-west-2.amazonaws.com/Images/meal-box/Dine_SpringOffice-49.jpg"},{"name":"og:image:secure_url","content":"https://anddinestorage.s3.eu-west-2.amazonaws.com/Images/meal-box/Dine_SpringOffice-49.jpg"},{"name":"og:image:alt","content":"&Dine"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"},{"rel":"canonical","href":"https://anddine.co.uk/"}],"style":[],"script":[],"noscript":[],"title":"&Dine - Delivering handmade food to your door."}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true